import { useFormContext, useWatch } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { FormInput, Loader, PasswordValidation } from 'components';
import { passwordRegex } from 'constants/regex';
import { routes } from 'router';

const UpdatePasswordForm = () => {
  const { t } = useTranslation();
  const {
    onSubmit,
    formState: { isValid },
    isLoading,
    request,
    getValues,
    trigger
  } = useFormContext();

  const password = useWatch('newPassword');

  const handlePasswordBlur = async () => {
    await trigger('newPassword');
  };

  return (
    <>
      {!request.success && !request.error && (
        <>
          <h1 className="h1 underlined-yellow mb-6">{t('auth:passwordUpdate.title')}</h1>
          <p className="text-sm lg:text-base text-gray-600 mb-2">
            <Trans i18nKey={'auth:passwordUpdate.description'}>
              <br />
            </Trans>
          </p>
          <form onSubmit={onSubmit}>
            <div className="relative mt-4">
              <FormInput
                name="newPassword"
                type="password"
                label={t('form:newPassword')}
                rules={{
                  required: true,
                  pattern: {
                    value: passwordRegex,
                    message: t('passwordInvalid')
                  }
                }}
                placeholder={t('form:newPassword')}
                onBlur={handlePasswordBlur}
              />
            </div>

            <PasswordValidation password={password.newPassword} />

            <div className="relative mt-8">
              <FormInput
                name="newPasswordConfirmation"
                type="password"
                label={t('form:newPasswordConfirmation')}
                rules={{
                  required: true,
                  validate: (value) => value === getValues('newPassword') || t('passwordConfirmationInvalid')
                }}
                placeholder={t('form:newPasswordConfirmation')}
              />
            </div>

            <button type="submit" disabled={!isValid || isLoading} className={'mt-6 btn mx-auto'}>
              {isLoading && <Loader loaderClass="w-4 h-4 text-white mr-2" />}
              {t('auth:passwordUpdate.button')}
            </button>
          </form>
        </>
      )}

      {request.success && (
        <>
          <div>
            <p>{t('auth:passwordUpdate.successContent')}</p>
          </div>
          <Link to={routes.login.path} className="btn mt-6 mx-auto">
            {t('auth:login.button')}
          </Link>
        </>
      )}

      {request.error && (
        <>
          <div>
            <p>{t('auth:passwordUpdate.error')}</p>
          </div>
          <Link to={routes.login.path} className="btn mt-6 mx-auto">
            {t('auth:login.button')}
          </Link>
        </>
      )}
    </>
  );
};

export default UpdatePasswordForm;
